import { isDefined } from '@e-socna/utils';

import type { StepCmpProps } from '../types/step-cmp-props.type';

export function checkIfIsStepCmpProps<V extends object, SE>(
  stepCmpProps: unknown,
): stepCmpProps is StepCmpProps<V, SE> {
  return (
    typeof stepCmpProps === 'object' &&
    isDefined(stepCmpProps) &&
    'id' in stepCmpProps
  );
}
